import log from "./services/log";
import config from "./services/config";
import { setupModule } from "./modules/setup/setupmodule";
import { appModule } from "./modules/app/app";
import { releaseModule } from "./modules/release/release";
import { estimationModule } from "./modules/estimation/estimation";
import { annotationsModule } from "./modules/annotations/annotations";
import Icons from "./icons";
import cardContextModule from "./modules/cardcontext/cardcontext";
import user from './services/user';
import authModule from './modules/auth/auth';
import cardbackModule, { cardBackModule } from './modules/cardback/cardback';

import ctx from './services/ctx';
// Main initalization block for capabilities

const init = () => {
    TrelloPowerUp.initialize(
        {
            "authorization-status": async (t: ITrelloClient, options) => {
                try {
                    const hasToken = await user(t).getHasToken()
                    return { authorized: hasToken };
                } catch (err) {
                    log.err(err);
                }
            },
            "show-authorization": async (t: ITrelloClient, options) => {
                try {
                    const isCompleted = await config(t).getSetupIsCompleted();

                    if (isCompleted) {
                        return setupModule.showUserAuth(t);
                    }

                    return setupModule.showSetupModalForOnBoarding(t);
                } catch (err) {
                    log.err(err);
                }
            },
            "show-settings": async (t, options) => {
                try {
                    const isCompleted = await config(t).getSetupIsCompleted();

                    if (isCompleted) {
                        return setupModule.showSetupModal(t);
                    }

                    return setupModule.showSetupModalForOnBoarding(t);
                } catch (err) {
                    log.err(err);
                }
            },
            "on-enable": async (t, options) => {
                try {
                    const isCompleted = await config(t).getSetupIsCompleted();

                    if (isCompleted) {
                        return setupModule.showSetupModal(t);
                    }

                    return setupModule.showSetupModalForOnBoarding(t);
                } catch (err) {
                    log.err(err);
                }
            },
            "on-disable": (t) => setupModule.disablePowerUp(t),
            "board-buttons": (t, opts) => {
                return buildTrelloUiElementListFrom<IBoardButtonsProvider>(
                    t,
                    opts,
                    (o, t, opts) => o.getBoardButtons(t, opts),
                    setupModule,
                    authModule,
                    appModule
                );
            },
            "list-actions": (t: ITrelloClient, opts) => {
                return buildTrelloUiElementListFrom<ICardListActionsProvider>(
                    t,
                    opts,
                    (o, t, opts) => o.getListActions(t, opts)
                );
            },
            "card-buttons": (t: ITrelloClient, opts) => {
                return buildTrelloUiElementListFrom<ICardButtonsProvider>(
                    t,
                    opts,
                    (o, t, opts) => o.getCardButtons(t, opts),
                    appModule,
                    authModule,
                    estimationModule
                );
            },
            "card-badges": (t: ITrelloClient, opts) => {
                return buildTrelloUiElementListFrom<ICardBadgesProvider>(
                    t,
                    opts,
                    (o, t, opts) => o.getCardBadges(t, opts),
                    appModule,
                    cardContextModule,
                    releaseModule,
                    estimationModule,
                    annotationsModule
                );
            },
            "card-back-section": async (t: ITrelloClient, opts) => {
                return cardBackModule.getCardBackSection(t,opts);
            },
            "card-detail-badges": (t: ITrelloClient, opts) => {
                return buildTrelloUiElementListFrom<ICardDetailsBadgesProvider>(
                    t,
                    opts,
                    (o, t, opts) => o.getCardDetailsBadges(t, opts),
                    cardContextModule,
                    releaseModule,
                    estimationModule,
                    annotationsModule
                );
            },
            "list-sorters": (t, opts) => {
                return buildTrelloUiElementListFrom<ICardListSortersProvider>(
                    t,
                    opts,
                    (o, t, opts) => o.getListSorters(t, opts),
                    estimationModule,
                    cardContextModule,
                    releaseModule
                );
            }
        },
        {
            helpfulStacks: true
        }
    )
};

init();

async function buildTrelloUiElementListFrom<T>(
    t,
    opts,
    f: (T, t, opts) => any,
    ...promises: Array<any>
) {
    try {
        return new Promise(async (resolve) => {
            var allPromisesList: Array<Promise<Array<any>>> = [];
            promises.forEachItem(p => {
                allPromisesList.push(f(p, t, opts));
            });
            try {
                const values = await Promise.all(allPromisesList);
                var allCapability = [];
                values.forEach(capabilityList => {
                    allCapability = allCapability.concat(capabilityList);
                });
                resolve(allCapability);
            }
            catch (err) {
                resolve([]);
                return log.err(err);
            }
        });
    }
    catch (err_1) {
        return log.err(err_1);
    }
}
